import { social } from "../data/site";

// Only the official Culture Diamond Instagram account is displayed.
export default function SocialIcons({ className = "", tone = "light" }) {
  const base =
    tone === "dark"
      ? "border-black/15 text-charcoal/60"
      : "border-white/15 text-cream/70";
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <a
        href={social.instagram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className={`flex h-9 w-9 items-center justify-center rounded-full border transition-all duration-300 hover:border-gold hover:text-gold ${base}`}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
        >
          <rect x="3" y="3" width="18" height="18" rx="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
        </svg>
      </a>
      <a
        href={social.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className={`font-sans text-sm tracking-wide transition-colors hover:text-gold ${
          tone === "dark" ? "text-charcoal/70" : "text-cream/70"
        }`}
      >
        {social.instagramHandle}
      </a>
    </div>
  );
}
